export default __webpack_public_path__ + "static/media/event-icon.ed986dfe.svg";